// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__2SOrv","form":"styles_form__Kf_a4"};